import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './auth.guard';
import { RoleGuardService } from './role.guard';
import { PageNotFound404Component } from './shared/page-not-found-404/page-not-found-404.component';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'oAuth'
  },
  {
    path: 'oAuth',
    loadChildren: () => import('./components/OAuth/oauth.module').then(m => m.OauthModule)
  },
  {
    path:'company-dashboard/:id',
    loadChildren:() => import('./components/company-dashboard/company-dashboard.module').then(m => m.CompanyDashboardModule),
    canActivate: [AuthGuard, RoleGuardService],
    data: {
      role: ['companyadmin']
    }
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./components/dashboard/dashboard-routing.module').then(m => m.DashboardRoutingModule),
    canActivate: [AuthGuard, RoleGuardService],
    data: {
      role: ['superadmin', 'dataadmin']
    }
  },
    {
    path: 'page-not-found',
    component: PageNotFound404Component
  },
  {
    path: '**',
    redirectTo: 'page-not-found'
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
